import { setupFormState } from '@/components/form/tidal-form'
import {
  AutocompleteOption as BulkAutocompleteOption,
  BulkTagsFieldValue,
} from '@/components/form/tidal-form/fields/Bulk/BulkTagsField'
import { AutocompleteOption, TagsFieldValue } from '@/components/form/tidal-form/fields/TagsField'

import { FormConfig } from '@workwave-tidal/core/form'
import { useMemo } from 'react'

export function TagsTester() {
  const config = useMemo<FormConfig<TesterValues>>(
    () => ({
      id: 'tagsTesterForm',
      initialValues: {
        singleTags: ['1', '2'],
        bulkTags: {
          'tags': {
            '1': { 'name': '1', 'status': 'exact', 'warning': false },
            '2': { 'name': '2', 'status': 'partial', 'warning': false, 'count': 1 },
            '3': { 'name': '3', 'status': 'partial', 'warning': false, 'count': 1 },
          },
        },
      },
    }),
    [],
  )

  return (
    <form.Form
      sx={{
        bgcolor: 'background.paper',
      }}
      config={config}
      title="Tags Field Tester"
      requireTransaction={false}
      stopEditingOnUnmount={false}
      applyPendingFitMapOnMount={false}
    >
      <form.TagsField name="singleTags" options={singleTagsOptions} label="Single Tag" />
      <form.BulkTagsField
        name="bulkTags"
        options={bulkTagsOptions}
        label="Bulk Tag"
        bulkTagsProps={{
          bannedTagCategory: 'tagsOut',
          totalSelectedItems: 2,
        }}
      />
    </form.Form>
  )
}

const singleTagsOptions: AutocompleteOption[] = [
  { value: '1', label: '1', disabled: false },
  { value: '2', label: '2', disabled: false },
  { value: '3', label: '3', disabled: false },
  { value: '4', label: '4', disabled: true },
  { value: '5', label: '5', disabled: false },
  { value: '6', label: '6', disabled: false },
]

const bulkTagsOptions: BulkAutocompleteOption[] = [
  { 'count': 1, 'label': '1', 'value': '1', 'allocationCount': 2, 'warning': false },
  { 'count': 0, 'label': '2', 'value': '2', 'allocationCount': 2, 'warning': true },
  { 'count': 0, 'label': '3', 'value': '3', 'allocationCount': 2, 'warning': false },
  { 'count': 0, 'label': '4', 'value': '4', 'allocationCount': 2, 'warning': false },
  { 'count': 0, 'label': '5', 'value': '5', 'allocationCount': 2, 'warning': false },
  { 'count': 0, 'label': '6', 'value': '6', 'allocationCount': 2, 'warning': false },
]

type TesterValues = {
  singleTags: TagsFieldValue
  bulkTags: BulkTagsFieldValue
}

const form = setupFormState<TesterValues>({
  id: 'tagsTesterForm',
  initialValues: {
    singleTags: ['1', '2'],
    bulkTags: {
      'tags': {
        '1': { 'name': '1', 'status': 'exact', 'warning': false },
        '2': { 'name': '2', 'status': 'partial', 'warning': false, 'count': 1 },
        '3': { 'name': '3', 'status': 'partial', 'warning': false, 'count': 1 },
      },
    },
  },
})
